<template>
  <div class="mx-2 pb-1" :class="screenType !== 'desktop' && uploadStep === 3 && 'remaining-space'">
    <StepForMobile
      :currentStep="3"
      :screenType="screenType"
      :title="this.$t('Sending & Filtering')"
    />
    <div
      v-if="isInMiddleOfFiltering && screenType !== 'desktop'"
      class="ml-1"
    >
      <UploadProgress
        class="overflow-auto"
        :filteringProgress="filteringProgress"
        :timer="timer"
        :session="session"
        :screenType="screenType"
      />
    </div>
  </div>
</template>

<script>
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import UploadProgress from '@/components/WebsiteInterface/CommonComponents/UploadProgress/UploadProgress.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Progress',
  props: {
    filteringProgress: Object,
    timer: Number,
    session: Object,
    screenType: String,
    isInMiddleOfFiltering: Boolean,
  },
  components: {
    StepForMobile,
    UploadProgress,
  },
  computed: {
    ...mapGetters(['uploadStep']),
  },
}
</script>
